/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Doctoral8Inputs */

const en_cv_extract_form_enum_doctoral8 = /** @type {(inputs: Cv_Extract_Form_Enum_Doctoral8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doctoral`)
};

const de_cv_extract_form_enum_doctoral8 = /** @type {(inputs: Cv_Extract_Form_Enum_Doctoral8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion`)
};

/**
* | output |
* | --- |
* | "Doctoral" |
*
* @param {Cv_Extract_Form_Enum_Doctoral8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_doctoral8 = /** @type {((inputs?: Cv_Extract_Form_Enum_Doctoral8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Doctoral8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_doctoral8(inputs)
	return en_cv_extract_form_enum_doctoral8(inputs)
});
export { cv_extract_form_enum_doctoral8 as "cv_extract_form_enum_DOCTORAL" }